<script setup lang="ts">
import { computed } from 'vue'

import { HeadingType } from '@xcel-next/core/enums'

import type { InterlineParagraph } from '../../utils/paragraph-schema/paragraphs'
const props = defineProps<{
  interline?: InterlineParagraph['interline']
}>()

type Heading = NonNullable<InterlineParagraph['interline']['heading']>

const heading = computed<Heading>(() => props.interline?.heading ?? HeadingType.h3)
const anchor = computed(() => props.interline?.anchor ?? '')
const text = computed(() => props.interline?.text ?? '')

const toInterlineTypeStyleClass = (heading: Heading): string =>
  'bx-typo--content-interline-' + heading
</script>

<template v-if="text && text.length > 0">
  <component :is="heading"
             :id="anchor"
             :class="['bx-content', 'bx-content__interline', 'bx-typo--content-interline', toInterlineTypeStyleClass(heading)]"
             :data-tc="`interline-${heading}`">
    {{ text }}
  </component>
</template>
